<div class="inner-content ion-text-center">
  <form [formGroup]="form">
    <h5 aria-level="1">{{ props.title | translate }}</h5>
    <ion-text
      *ngIf="showReasonForDeletion"
      class="text--sm"
    >
      {{ props.description | translate }}
    </ion-text>

    <!-- Reason for Deletion (Admin only - for event owner) -->
    <div
      *ngIf="showReasonForDeletion"
      class="mt-4"
    >
      <ion-item>
        <ion-textarea
          formControlName="reasonForDeletion"
          [placeholder]="
            'MODALS.EVENT_DELETION.REASON_FOR_DELETION_PLACEHOLDER' | translate
          "
          labelPlacement="stacked"
          fill="outline"
          rows="3"
          autoGrow="true"
          data-cy="reason-for-deletion-input"
        ></ion-textarea>
      </ion-item>
      <ion-text
        *ngIf="
          showReasonForDeletion &&
          form.get('reasonForDeletion')?.invalid &&
          form.get('reasonForDeletion')?.touched
        "
        color="danger"
        class="text--xs"
      >
        {{ "COMMON.VALIDATION.REQUIRED" | translate }}
      </ion-text>
    </div>

    <!-- Cancellation Reason (for participants) -->
    <div class="mt-4">
      <ion-item>
        <ion-textarea
          formControlName="cancellationReason"
          [placeholder]="
            'MODALS.EVENT_DELETION.CANCELLATION_REASON_PLACEHOLDER' | translate
          "
          labelPlacement="stacked"
          fill="outline"
          rows="3"
          autoGrow="true"
          data-cy="cancellation-reason-input"
        ></ion-textarea>
      </ion-item>
    </div>

    <ion-button
      class="mt-6"
      (click)="onConfirm()"
      expand="block"
      [color]="props.confirmColor || 'danger'"
      [disabled]="!canConfirm"
      data-cy="confirm-btn"
    >
      {{ props.confirmLabel | translate }}
    </ion-button>

    <ion-button
      class="mt-4"
      expand="block"
      color="light"
      (click)="onCancel()"
      data-cy="cancel-btn"
    >
      {{ props.cancelLabel | translate }}
    </ion-button>
  </form>
</div>
